module.exports = __webpack_public_path__ + "img/contactos-web.ac342189.png";